import HttpRequest from '@Services/RequestFactory';

// eslint-disable-next-line import/prefer-default-export
export const getOptionalParams = ({ sort, order, citRefResultName, hitData, firstSubItem, semanticSearchIncluded, semanticResultName }) => {
  const optional = {};

  if (sort) {
    optional.sort = sort;
  }
  if (order) {
    optional.order = order;
  }
  if (citRefResultName) {
    // tgitems context requires to add citRefResultName param to URL for all requests with firstItem > 1
    optional.citRefResultName = citRefResultName;
  }
  if (hitData) {
    // to get hitSubstances or hitReactions for citations context
    optional.hitData = hitData;
  }
  if (firstSubItem) {
    // Patent Family Clustering
    optional.firstSubItem = firstSubItem;
  }

  if (semanticSearchIncluded) {
    optional.semanticSearchIncluded = semanticSearchIncluded;
  }

  if (semanticResultName) {
    optional.semanticResultName = semanticResultName;
  }

  return HttpRequest.generateUrlQuery(optional);
};
